import forEach from "lodash/forEach";
import { NODE_GROUP_MIN_SIZE } from "Areas/Documents/graph/constants";
import { ENTITY_TYPES } from "Areas/Documents/graph/NeuralInterface/NeuralInterfaceContext/CreateNodeSource";
import nodeSourceFactory from "Areas/Documents/graph/utils/nodeOrEdgeSourceDataHandling/nodeSourceFactory";
import addOrUpdateNodeLabel from "Areas/Documents/graph/utils/nodeRendering/addOrUpdateNodeLabel";
export function createRegularNodes({ graphComponentRef, graph, jsonGraphModel, nodeMap, nodesSource, documentObjects, groups }) {
    forEach(jsonGraphModel.Nodes, nodeData => {
        var _a, _b, _c, _d;
        const source = nodesSource[nodeData.Id];
        const isGroup = groups[nodeData.Id];
        if (isGroup ||
            source.PinnedToGroup ||
            (nodeData.ParentId && ENTITY_TYPES.includes(nodeData.ParentId))) {
            return;
        }
        if (nodeMap.has(nodeData.Id)) {
            console.warn(`Узел уже существует: ${nodeData.Id}. Пропуск создания.`);
            return;
        }
        try {
            const node = graph.createNode({
                layout: {
                    x: (_a = nodeData.X) !== null && _a !== void 0 ? _a : 0,
                    y: (_b = nodeData.Y) !== null && _b !== void 0 ? _b : 0,
                    width: (_c = nodeData.Width) !== null && _c !== void 0 ? _c : NODE_GROUP_MIN_SIZE.width,
                    height: (_d = nodeData.Height) !== null && _d !== void 0 ? _d : NODE_GROUP_MIN_SIZE.height
                },
                tag: nodeSourceFactory({ ...nodeData, ...source }, documentObjects)
            });
            addOrUpdateNodeLabel(graphComponentRef, node, node.tag.DocumentObject);
            nodeMap.set(nodeData.Id, node);
        }
        catch (ex) {
            console.error(`Не удалось создать узел: ${nodeData.Id}`, ex);
        }
    });
}
